import * as actions from "./actions";

let initialState = {
  events: {
    fetching: false,
    fetched: false,
    data: [],
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 50 },
    },
  },

  eventsByKey: {
    fetching: false,
    fetched: false,
    data: [],
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 50 },
    },
  },

  initStatus: {
    fetching: false,
    fetched: false,
    data: {},
  },

  resetStatus: {
    fetching: false,
    fetched: false,
    data: {},
  },

  routerRestart: {
    fetching: false,
    fetched: false,
    error: undefined,
    data: undefined,
  },

  projectionsRestart: {
    fetching: false,
    fetched: false,
    error: undefined,
    data: undefined,
  },
};

const browser = (state = initialState, action) => {
  switch (action.type) {
    case actions.INIT_STATUS_GET_SUCCESS:
      return Object.assign({}, state, {
        initStatus: Object.assign({}, state.initStatus, {
          fetched: true,
          fetching: false,
          data: action.response,
        }),
      });
    case actions.RESET_STATUS_GET_SUCCESS:
      return Object.assign({}, state, {
        resetStatus: Object.assign({}, state.resetStatus, {
          fetched: true,
          fetching: false,
          data: action.response,
        }),
      });
    case actions.RESTART_ROUTER_REQUEST:
      return Object.assign({}, state, {
        routerRestart: Object.assign({}, state.projectionsRestart, {
          fetching: true,
        }),
      });
    case actions.RESTART_ROUTER_SUCCESS:
      return Object.assign({}, state, {
        routerRestart: Object.assign({}, state.routerRestart, {
          fetched: true,
          fetching: false,
          data: action.response,
        }),
      });
    case actions.RESTART_ROUTER_ERROR:
      return Object.assign({}, state, {
        routerRestart: Object.assign({}, state.routerRestart, {
          fetched: false,
          fetching: false,
          error: action.error,
        }),
      });
    case actions.RESTART_PROJECTIONS_REQUEST:
      return Object.assign({}, state, {
        projectionsRestart: Object.assign({}, state.projectionsRestart, {
          fetching: true,
        }),
      });
    case actions.RESTART_PROJECTIONS_SUCCESS:
      return Object.assign({}, state, {
        projectionsRestart: Object.assign({}, state.routerRestart, {
          fetched: true,
          fetching: false,
          data: action.response,
        }),
      });
    case actions.RESTART_PROJECTIONS_ERROR:
      return Object.assign({}, state, {
        projectionsRestart: Object.assign({}, state.routerRestart, {
          fetched: false,
          fetching: false,
          error: action.error,
        }),
      });
    //Event List
    case actions.GET_EVENT_LIST_REQUEST:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          fetching: true,
          fetchError: null,
          data: null,
        }),
      });

    case actions.GET_EVENT_LIST_SUCCESS:
      var data = [];

      for (var key of Object.keys(action.response)) {
        for (var item of action.response[key]) {
          data.push({
            ...item,
            TimeStamp: item["Item2"].TimeStamp,
            SequenceNumber: item["Item2"].SequenceNumber,
            Id: key,
          });
        }
      }

      data = data.sort((a, b) => {
        var byTimeStamp = new Date(b.TimeStamp) - new Date(a.TimeStamp);
        return byTimeStamp == 0
          ? b.SequenceNumber - a.SequenceNumber
          : byTimeStamp;
      });

      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          fetching: false,
          fetched: true,
          data,
        }),
      });

    case actions.GET_EVENT_LIST_ERROR:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          fetching: false,
          error: action.error,
        }),
      });

    case actions.EVENT_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          table: Object.assign({}, state.events.table, {
            pagination: Object.assign({}, state.events.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });

    case actions.EVENT_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        events: Object.assign({}, state.events, {
          table: Object.assign({}, state.events.table, {
            currentFilter: Object.assign({}, state.events.table.currentFilter, {
              ...action.filter,
            }),
          }),
        }),
      });
    //Events by key
    case actions.GET_EVENT_BY_KEY_LIST_REQUEST:
      return Object.assign({}, state, {
        eventsByKey: Object.assign({}, state.eventsByKey, {
          fetching: true,
          fetchError: null,
          data: null,
        }),
      });

    case actions.GET_EVENT_BY_KEY_LIST_SUCCESS:
      var dataInternal = [];

      for (var keyInternal of Object.keys(action.response)) {
        for (var itemInternal of action.response[keyInternal]) {
          dataInternal.push({
            ...itemInternal,
            TimeStamp: itemInternal["Item2"].TimeStamp,
            SequenceNumber: itemInternal["Item2"].SequenceNumber,
            Id: keyInternal,
          });
        }
      }

      dataInternal = dataInternal.sort((a, b) => {
        var byTimeStamp = new Date(b.TimeStamp) - new Date(a.TimeStamp);
        return byTimeStamp == 0
          ? b.SequenceNumber - a.SequenceNumber
          : byTimeStamp;
      });

      return Object.assign({}, state, {
        eventsByKey: Object.assign({}, state.eventsByKey, {
          fetching: false,
          fetched: true,
          data: dataInternal,
        }),
      });

    case actions.GET_EVENT_BY_KEY_LIST_ERROR:
      return Object.assign({}, state, {
        eventsByKey: Object.assign({}, state.eventsByKey, {
          fetching: false,
          error: action.error,
        }),
      });

    case actions.EVENT_BY_KEY_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        eventsByKey: Object.assign({}, state.eventsByKey, {
          table: Object.assign({}, state.eventsByKey.table, {
            pagination: Object.assign({}, state.eventsByKey.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });

    case actions.EVENT_BY_KEY_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        eventsByKey: Object.assign({}, state.eventsByKey, {
          table: Object.assign({}, state.eventsByKey.table, {
            currentFilter: Object.assign(
              {},
              state.eventsByKey.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    default:
      return state;
  }
};

export default browser;
